import { useCallback } from 'react';
import { apiBaseUrl } from '../../../util/api';

const useBuckChatHandlers = ({
  onRefreshAuthState,
  onAddFavoritePackage,
  listingId,
  packageId,
}) => {
  const handleAnalyticsEvent = useCallback((event, data) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'dl_push',
        mp_event: event,
        mp_properties: data,
      });
    }
  }, []);

  const handleAuthSuccess = useCallback(async () => {
    // Update Redux auth state without page reload to preserve chat context
    try {
      await onRefreshAuthState();
      // Add package to favorites after successful signup/login
      if (packageId) {
        await onAddFavoritePackage(listingId, packageId);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('BuckChat auth state update failed:', error);
      // Fallback to page reload if Redux update fails
      window.location.reload();
    }
  }, [onRefreshAuthState, onAddFavoritePackage, listingId, packageId]);

  const handleLtPlusSuccess = useCallback(async () => {
    // Refresh Redux auth/currentUser state so LT+ metadata updates without full page reload.
    try {
      await onRefreshAuthState();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('BuckChat LT+ state update failed:', error);
      // Fallback to page reload if Redux update fails
      window.location.reload();
    }
  }, [onRefreshAuthState]);

  const handleFetchPackage = useCallback(async (fetchListingId, fetchPackageId) => {
    const response = await fetch(`${apiBaseUrl()}/api/packages`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ listingId: fetchListingId, packageId: fetchPackageId }),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch package: ${response.status}`);
    }

    return response.json();
  }, []);

  return { handleAnalyticsEvent, handleAuthSuccess, handleLtPlusSuccess, handleFetchPackage };
};

export default useBuckChatHandlers;
